import MarkdownRender from 'components/Luxkit/MarkdownRender'
import React from 'react'
import OfferDescription from '../OfferDescription'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LineMapMarkerIcon from 'components/Luxkit/Icons/line/LineMapMarkerIcon'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import TextLink from 'components/Luxkit/TextLink'
import { mediaQueryUp } from 'components/utils/breakpoint'
import styled from 'styled-components'
import { rem } from 'polished'
import Image from 'components/Common/Image'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${mediaQueryUp.tablet} {
    grid-row: 2;
    grid-column: span 2;
  }

  ${mediaQueryUp.desktop} {
    grid-column: 1;
  }
`

const PropertyLogo = styled(Image)`
  display: none;

  ${mediaQueryUp.desktop} {
    margin-left: ${rem(16)};
    display: block;
    height: ${rem(75)};
  }
`

interface Props {
  offer: App.Offer
  property: App.OfferProperty
  location: string
}

function LastMinutePropertyDetails(props: Props) {
  const { offer, property, location } = props

  return (<>
    <Header>
      <VerticalSpacer gap={8}>
        <BodyTextBlock variant="medium" data-testid="offer-location" startIcon={<LineMapMarkerIcon />}>
          {location} • <TextLink href="#getting-there">view map</TextLink>
        </BodyTextBlock>
        <Heading variant="heading2" as="h1">{offer.property?.name}</Heading>
        <BodyText variant="large" as="h2">{offer.name}</BodyText>
      </VerticalSpacer>
      {property.logoImageId &&
        <PropertyLogo
          dpr={2}
          height={75}
          enhancedFormats={false}
          id={property.logoImageId}
          alt={`${property.name || 'Vendor'} logo`}
        />}
    </Header>
    <div>
      {offer.description && <OfferDescription description={offer.description} />}
      {offer.additionalDescription && <MarkdownRender type="compact" fontSize="medium" content={offer.additionalDescription} />}
    </div>
  </>)
}

export default LastMinutePropertyDetails
